import { ClipperProps } from '@components/Clipper';
import { PaywallProps } from '@components/Paywall';
import { Env } from '@contexts/AppContext';
import { SubscriberCouncilPartner } from '@interfaces/partners';
import { User } from '@utils/backend-api/currentUser';

import { Article, MostPopularArticle } from '../../../interfaces/homepage';

export enum ArticleTheme {
  Feature = 'feature',
  Standard = 'standard',
  Weekend = 'weekend',
}

type ArticlePaywallProps = Omit<PaywallProps, 'articleId' | 'briefingGuid' | 'trackingProps'>;

export interface ArticleProps extends ThemeViewsProps {
  isGdprRequired: boolean;
  isWebview: boolean;
  newsletter?: NewsletterProps;
  paywallProps?: ArticlePaywallProps;
  theme: ArticleTheme;
}

export interface NewsletterProps {
  description: string;
  frequency: string;
  id: number;
  isSubscribed: boolean;
  name: string;
}

export interface ThemeViewsProps {
  article: Article;
  canViewFullArticle: boolean;
  clipperProps: ClipperProps;
  env: Env;
  isFullyFreeArticle: boolean;
  initialCurrentUser?: User;
  isGooglebot: boolean;
  mostPopularArticles: MostPopularArticle[];
  newsletter?: NewsletterProps;
  relatedArticles: Article[];
  shareLink?: string;
  subscriberCouncil: SubscriberCouncilPartner[];
}
